import React, { useState, useCallback, useRef } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    Progress,
    ModalFooter,
} from "reactstrap";

import { toast } from "react-toastify";
import API from "../../Network/API";
import { useDispatch, useSelector } from "react-redux";
import { ADD_POST_FETCH_SUCCESS, UPLOAD_START, UPLOAD_PROGRESS, UPLOAD_DONE } from "../../Reducer/postReducer";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { compressVideo, formatSize, VideoTooLongError, quickValidateVideo } from "../../utils/videoCompressor";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DOMPurify from "dompurify";
import EmojiPicker from "emoji-picker-react";


export default function PostCreateModal(props) {
    const fileObj = [];
    const fileArrayAnotherImage = [];
    const fileArrayAnother = [];
    const fileArrayVideo = [];
    const fileArray = [];
    const [isLoading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [message, setMessage] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileUrl, setFileUrl] = useState(null);
    const [files, setFile] = useState([]);
    const [fileArrayImage, setFileArray] = useState([]);
    const [post_modalDialog, setPostShareModalDialog] = useState(false);
    const [video_url, setVideoUrl] = useState('');
    const [nudityWarning, setNudityWarning] = useState("");
    const [statusText, setStatusText] = useState('');
    const [sizeInfo, setSizeInfo] = useState(null); // { original, compressed }
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const fileInput = React.useRef();
    const quillRef = useRef(null);
    const photoInputRef = useRef(null);
    const videoInputRef = useRef(null);
    const dispatch = useDispatch();
    const uploadInProgress = useSelector((s) => s.postReducer.uploadInProgress);
    const navigate = useNavigate();
    const { t } = useTranslation();

    const myArr = JSON.parse(localStorage.getItem('user_data'));
    let msgText = t('Whats on your mind') + ", " + (localStorage.getItem("profile_name") || "") + "?";

    const removeImage = (url, indexNumber) => {
        const index = files.indexOf(url);
        if (index > -1) { // only splice array when item is found
            files.splice(index, 1); // 2nd parameter means remove one item only
        }
        setFile([...files, files])
        removeElement(indexNumber)

    }

    const removeElement = (index) => {
        const filesf = files.filter((_, i) => i !== index);
        const filesOrginal = fileArrayImage.filter((_, i) => i !== index);
        setFile(filesf); // this array reset for display instant image showing
        setFileArray(filesOrginal); // this array reset for upload to server
    };

    const uploadHandlerSecondInput = (e) => {
        if (!e.target.files || e.target.files.length === 0) return;
        if (Array.from(e.target.files).some(isHeicFile)) {
            toast.error("HEIC photos aren't supported in the browser. Please convert them to JPEG and try again.");
            return;
        }
        setSelectedFile(e.target.files[0]);
        setFileUrl(URL.createObjectURL(e.target.files[0]))
        fileObj.push(e.target.files)
        for (let i = 0; i < fileObj[0].length; i++) {
            let extn = e.target.files[i].name.split('.').pop();

            if (extn.toLowerCase() === 'mp4' || extn.toLowerCase() === 'wmv' || extn.toLowerCase() === 'avi' || extn.toUpperCase() === "MKV" || extn.toUpperCase() === "WEBM" || extn.toUpperCase() === "MOV") {
                fileArrayVideo.push(URL.createObjectURL(fileObj[0][i]));

            } else {
                fileArray.push(URL.createObjectURL(fileObj[0][i]))
            }


            if (fileArrayImage.indexOf(fileObj[0][i]) === -1) {
                fileArrayAnother.push(fileObj[0][i])
            }

            if (files.indexOf(URL.createObjectURL(fileObj[0][i])) === -1) {
                fileArrayAnotherImage.push(URL.createObjectURL(fileObj[0][i]))
            }




        }

        setFileArray([...fileArrayImage, ...fileArrayAnother]) // this is for upload to server
        setFile([...files, ...fileArrayAnotherImage]) // this is for display

    }

    const uploadHandler = async (e) => {
        if (!e.target.files || e.target.files.length === 0) return;

        const newFiles = [];      // File objects for upload
        const newUrls = [];       // URLs for display

        for (let i = 0; i < e.target.files.length; i++) {
            const file = e.target.files[i];

            if (isHeicFile(file)) {
                toast.error(`"${file.name}" is a HEIC photo, which browsers can't display. Please convert it to JPEG and try again.`);
                continue;
            }

            // Instant validation for video files
            if (file.type?.startsWith('video/') || isVideoFile(file)) {
                const validation = await quickValidateVideo(file);
                if (!validation.valid) {
                    toast.error(validation.error);
                    continue; // Skip this file, don't add it
                }
            }

            newFiles.push(file);
            newUrls.push(URL.createObjectURL(file));
        }

        if (newFiles.length === 0) return;

        setSelectedFile(newFiles[0]);
        setFileUrl(URL.createObjectURL(newFiles[0]));

        // Append to existing files instead of overwriting
        setFileArray(prev => [...prev, ...newFiles]);
        setFile(prev => [...prev, ...newUrls]);
    }


    const VIDEO_EXTENSIONS = ['MP4', 'WMV', 'AVI', 'MKV', 'WEBM', 'MOV', 'QT', 'FLV', 'OGG'];

    function isVideoFile(file) {
        const ext = file.name.split('.').pop().toUpperCase();
        return VIDEO_EXTENSIONS.includes(ext) || file.type?.startsWith('video/');
    }

    // Browsers can't decode/preview HEIC (iOS photo format); iOS Safari
    // converts to JPEG automatically, so this only catches raw .heic files.
    function isHeicFile(file) {
        const ext = file.name.split('.').pop().toLowerCase();
        return ext === 'heic' || ext === 'heif'
            || file.type === 'image/heic' || file.type === 'image/heif';
    }

    async function onCreatePost() {
        const cleanMessage = DOMPurify.sanitize(message);
        const strippedMessage = cleanMessage.replace(/(<([^>]+)>)/gi, "").trim();

        if (selectedFile === null && !strippedMessage) {
            toast.error("Post is empty");
            return false;
        }

        // --- Snapshot files into closure so the work survives modal unmount ---
        const allFiles = fileArrayImage && fileArrayImage.length > 0
            ? [...fileArrayImage]
            : selectedFile != null ? [selectedFile] : [];
        const imageFiles = allFiles.filter(f => !isVideoFile(f));
        const videoFiles = allFiles.filter(f => isVideoFile(f));

        // --- Reset form & close modal immediately; upload continues in background ---
        setFile([]);
        setFileArray([]);
        setSelectedFile(null);
        setMessage("");
        setNudityWarning("");
        localStorage.setItem('message', '');
        dispatch(UPLOAD_START());
        props.handleShowB();

        try {
            // --- Phase 1: Compress videos (0-30% progress) ---
            const compressedVideos = [];
            if (videoFiles.length > 0) {
                let totalOriginal = 0;
                let totalCompressed = 0;

                for (let i = 0; i < videoFiles.length; i++) {
                    const startTime = Date.now();

                    const result = await compressVideo(videoFiles[i], (p) => {
                        const base = (i / videoFiles.length) * 30;
                        const portion = (1 / videoFiles.length) * 30;
                        dispatch(UPLOAD_PROGRESS({ progress: Math.round(base + (p * portion)) }));
                    }, (msg) => {
                        console.log('Compress:', msg);
                        if (msg.includes('WebCodecs') && msg.includes('hardware')) {
                            dispatch(UPLOAD_PROGRESS({ statusText: '⚡ Compressing...' }));
                        } else if (msg.includes('WebCodecs failed')) {
                            dispatch(UPLOAD_PROGRESS({ statusText: '🔧 Compressing...' }));
                        } else if (msg.includes('FFmpeg') && !msg.includes('failed')) {
                            dispatch(UPLOAD_PROGRESS({ statusText: '🔧 Compressing...' }));
                        }
                    });

                    const elapsed = ((Date.now() - startTime) / 1000).toFixed(1);

                    compressedVideos.push(result.file);
                    totalOriginal += result.originalSize;
                    totalCompressed += result.compressedSize;

                    if (!result.skipped) {
                        const method = result.method === 'webcodecs' ? '' : '';
                        toast.info(`${method} • ${elapsed}s • ${formatSize(totalOriginal)} → ${formatSize(totalCompressed)}`, { autoClose: 5000 });
                        dispatch(UPLOAD_PROGRESS({
                            sizeInfo: {
                                original: formatSize(totalOriginal),
                                compressed: formatSize(totalCompressed),
                            },
                        }));
                    }
                }
            }

            dispatch(UPLOAD_PROGRESS({ progress: 30, statusText: 'Uploading...', sizeInfo: null }));

            // --- Phase 2: Upload (30-80% progress) ---
            const fd = new FormData();
            for (const img of imageFiles) {
                fd.append('image[]', img, img.name);
            }
            for (const vid of compressedVideos) {
                fd.append('video[]', vid, vid.name);
            }
            if (strippedMessage !== "") {
                fd.append('details', cleanMessage);
            }

            const response = await API.post("/v1/posts", fd, {
                onUploadProgress: (progressEvent) => {
                    const uploadPct = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    // Map upload 0-100% into overall 30-80%
                    dispatch(UPLOAD_PROGRESS({ progress: 30 + Math.round(uploadPct * 0.5) }));
                }
            });

            // --- Phase 3: Publish (80-100%) ---
            dispatch(UPLOAD_PROGRESS({ progress: 90, statusText: 'Publishing...' }));

            if (response.data.success === true) {
                dispatch(UPLOAD_PROGRESS({ progress: 100 }));
                const hasVideo = compressedVideos.length > 0;
                if (hasVideo) {
                    toast.success("Your video is uploaded, it will be posted shortly.");
                } else {
                    toast.success(response.data.message);
                    dispatch(ADD_POST_FETCH_SUCCESS(response.data.data));
                }
            } else if (response.data.success === false) {
                toast.error(response.data.message || "Post failed");
            }
        } catch (err) {
            if (err instanceof VideoTooLongError) {
                const maxMin = Math.floor(err.maxSeconds / 60);
                toast.error(`Video is too long (max ${maxMin} minutes)`);
            } else if (err?.response) {
                const status = err.response.status;
                if (status === 422) {
                    const imageError = err.response.data?.data?.image;
                    const serverMsg = Array.isArray(imageError) ? imageError[0] : imageError;
                    if (typeof serverMsg === 'string' && !serverMsg.includes('NSFW')) {
                        toast.error(serverMsg);
                    } else {
                        toast.warning("This post might contain nudity or explicit content that violates ConnectsApp content policy.");
                    }
                } else if (status === 413) {
                    toast.error("File is too large. Maximum size is 200MB.");
                } else if (status === 500) {
                    toast.error("Server error. Please try again later.");
                } else {
                    toast.error(`Upload failed (Error ${status}). Please try again.`);
                }
            } else if (err?.code === 'ECONNABORTED') {
                toast.error("Upload timed out. Please check your connection.");
            } else {
                console.error('Post error:', err);
                toast.error("Something went wrong. Please try again.");
            }
        } finally {
            dispatch(UPLOAD_DONE());
        }
    }

    const POST_MAX_LENGTH = 63206;

    const inputValue = (value) => {
        setMessage(value)
        localStorage.setItem('message', value)
    }

    const onEmojiClick = (emojiObject) => {
        if (!quillRef.current) return;
        const quill = quillRef.current.getEditor();
        quill.focus();
        const cursorPosition = quill.getSelection()?.index || quill.getLength();
        quill.insertText(cursorPosition, emojiObject.emoji);
        quill.setSelection(cursorPosition + emojiObject.emoji.length);
        setShowEmojiPicker(false);
    };

    const modules = {
        toolbar: [
            ['bold', 'italic'],
            ['clean']
        ],
    };

    const formats = [
        'bold', 'italic'
    ];

    const handlePaste = async (e) => {
        // Handle file pastes (images)
        if (e.clipboardData.files.length) {
            const fileObject = e.clipboardData.files[0];
            setSelectedFile(fileObject);
            setFileUrl(URL.createObjectURL(fileObject))
            fileArray.push(URL.createObjectURL(e.clipboardData.files[0]))
            fileArrayAnother.push(e.clipboardData.files[0])
            fileArrayAnotherImage.push(URL.createObjectURL(e.clipboardData.files[0]))
            setFileArray([...fileArrayImage, e.clipboardData.files[0]])
            setFile([...files, URL.createObjectURL(fileObject)]) // this is for display
            return;
        }
    }


    const dropZoneRef = useRef(null);

    const handleDrop = (e) => {
        e.preventDefault();
        const fileObject = e.dataTransfer.files[0];

        setSelectedFile(fileObject);
        setFileUrl(URL.createObjectURL(fileObject))
        fileArray.push(URL.createObjectURL(fileObject))
        fileArrayAnother.push(fileObject)
        fileArrayAnotherImage.push(URL.createObjectURL(fileObject))
        setFileArray([...fileArrayImage, fileObject])
        setFile([...files, URL.createObjectURL(fileObject)]) // this is for display
        //   // Create a new FileReader to read the contents of the dropped image file
        //   const reader = new FileReader();

        //   reader.onload = (event) => {
        //     const imageUrl = event.target.result;
        //     const clipboardItem = new ClipboardItem({ 'image/png': imageFile });
        //     navigator.clipboard.write([clipboardItem])
        //       .then(() => console.log('Image copied to clipboard'))
        //       .catch((error) => console.error('Could not copy image to clipboard: ', error));
        //   };

        //   reader.readAsDataURL(imageFile);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    return (<>
        <Modal
            isOpen={props.isModalVisible}
            size=""
            toggle={props.handleShowB}
            onOpened={() => {
                if (quillRef.current) {
                    const quill = quillRef.current.getEditor();
                    if (quill) {
                        quill.focus();
                        quill.setSelection(quill.getLength(), 0);
                    }
                }
                // Resize modal when mobile keyboard appears
                if (window.visualViewport) {
                    const handler = () => {
                        const modal = document.querySelector('.post-create-modal .modal-content');
                        if (modal) {
                            modal.style.height = window.visualViewport.height + 'px';
                        }
                    };
                    window.visualViewport.addEventListener('resize', handler);
                    // Store for cleanup
                    window._postModalVVHandler = handler;
                    handler(); // apply immediately
                }
            }}
            onClosed={() => {
                if (window.visualViewport && window._postModalVVHandler) {
                    window.visualViewport.removeEventListener('resize', window._postModalVVHandler);
                    delete window._postModalVVHandler;
                }
            }}
            className={'modal-dialog-scrollable post-create-modal'}
            modalClassName={'post-create-modal-root'}
            zIndex={10050}
            backdropClassName={'post-create-modal-backdrop'}
            backdrop="static"
        >
            <ModalHeader toggle={props.handleShowB} id={'staticBackdropLabel'} className={'new-post-modal-header'}
                style={{ display: 'flex', alignItems: 'center' }}
            >
                <span>{t('Create New Post')}</span>
            </ModalHeader>
            <ModalBody style={{ display: 'flex', flexDirection: 'column', padding: '0px 16px 16px 16px' }}>
                <div style={{ flex: 1 }}>
                    <style>{`
                    .quill-minimal .ql-toolbar.ql-snow {
                        border: none;
                        border-bottom: 1px solid #eee;
                        padding: 8px 0;
                        margin-bottom: 0px;
                    }
                    .quill-minimal .ql-container.ql-snow {
                        border: none;
                        font-size: 1.1rem;
                        font-family: inherit;
                    }
                    .quill-minimal .ql-editor {
                        padding: 0;
                        padding-top: 10px;
                        min-height: 140px;
                    }
                    .quill-minimal .ql-editor.ql-blank::before {
                        left: 0;
                        font-style: normal;
                        color: #999;
                    }
                `}</style>

                    <div className="share_post_write_text mt-2 mb-2" >
                        <form ref={dropZoneRef} onDrop={handleDrop} onDragOver={handleDragOver} onPaste={(e) => handlePaste(e)}>
                            <div className="form-group position-relative">
                                <ReactQuill
                                    ref={quillRef}
                                    theme="snow"
                                    value={message}
                                    onChange={(content, delta, source, editor) => inputValue(editor.getHTML())}
                                    modules={modules}
                                    formats={formats}
                                    placeholder={msgText}
                                    className="quill-minimal"
                                />

                                <div className="emoji-picker-container" style={{ position: 'absolute', top: '0px', right: '0px', zIndex: 50 }}>
                                    <button
                                        type="button"
                                        className="btn btn-light btn-sm rounded-circle shadow-sm"
                                        onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                                        title="Add Emoji"
                                        style={{ padding: '0px', width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '4px' }}
                                    >
                                        😊
                                    </button>
                                    {showEmojiPicker && (
                                        <div style={{ position: 'absolute', top: '35px', right: '0', zIndex: 1055 }}>
                                            <EmojiPicker onEmojiClick={onEmojiClick} theme="light" />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>

                    {/* 3-phase progress bar */}
                    {progress > 0 && (
                        <div style={{ marginTop: '8px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                                <span style={{ fontSize: '13px', fontWeight: 600, color: '#555' }}>
                                    {statusText && <><i className={`fas ${statusText === 'Compressing...' ? 'fa-compress' : statusText === 'Uploading...' ? 'fa-cloud-upload-alt' : 'fa-check-circle'} me-1`} />{statusText}</>}
                                </span>
                                {sizeInfo && (
                                    <span style={{ fontSize: '12px', color: '#45bd62', fontWeight: 600 }}>
                                        {sizeInfo.original} → {sizeInfo.compressed}
                                    </span>
                                )}
                            </div>
                            <Progress
                                value={progress}
                                color={progress >= 100 ? 'success' : progress >= 80 ? 'info' : 'primary'}
                                style={{ height: '6px', borderRadius: '3px' }}
                            />
                        </div>
                    )}

                    {/* Media previews */}
                    {files.length > 0 && (
                        <div className="d-flex flex-nowrap overflow-auto gap-2 py-2">
                            {(fileArrayImage || []).map((url, index) => (
                                <div className="position-relative" key={index} id={window.URL.createObjectURL(url)} style={{ minWidth: '120px', maxWidth: '160px' }}>
                                    {url.type?.startsWith('image/') ?
                                        <div style={{ height: '120px', borderRadius: '8px', overflow: 'hidden' }}>
                                            <img src={window.URL.createObjectURL(url)} alt="preview"
                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        </div>
                                        : url.type?.startsWith('video/') ?
                                            <div style={{ height: '120px', borderRadius: '8px', overflow: 'hidden', position: 'relative' }}>
                                                <video style={{ width: '100%', height: '100%', objectFit: 'cover' }}>
                                                    <source src={window.URL.createObjectURL(url)} />
                                                </video>
                                                <div style={{ position: 'absolute', bottom: '4px', left: '4px', background: 'rgba(0,0,0,0.6)', borderRadius: '4px', padding: '1px 6px' }}>
                                                    <i className="fas fa-play text-white" style={{ fontSize: '10px' }} />
                                                </div>
                                            </div>
                                            : null
                                    }
                                    <div className="position-absolute" style={{ top: '4px', right: '4px', cursor: 'pointer' }}>
                                        <i className="fas fa-times-circle text-white"
                                            style={{ fontSize: '18px', filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.5))' }}
                                            onClick={() => removeImage(window.URL.createObjectURL(url), index)} />
                                    </div>
                                    {index === 0 && (
                                        <div className="position-absolute" style={{ top: '4px', left: '4px' }}>
                                            <label style={{ cursor: 'pointer', background: 'rgba(0,0,0,0.6)', borderRadius: '4px', padding: '2px 6px' }}>
                                                <i className="fas fa-plus text-white" style={{ fontSize: '12px' }} />
                                                <input type="file" onChange={uploadHandlerSecondInput}
                                                    multiple={true} accept="audio/*,video/*,image/*" style={{ display: 'none' }} />
                                            </label>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}

                    {nudityWarning && (
                        <div className="alert alert-warning mt-2" role="alert">
                            {nudityWarning}
                        </div>
                    )}

                    {/* Hidden file inputs */}
                    <input ref={photoInputRef} type="file" onChange={uploadHandler}
                        multiple={true} accept="image/*" style={{ display: 'none' }} />
                    <input ref={videoInputRef} type="file" onChange={uploadHandler}
                        multiple={false} accept="video/*" style={{ display: 'none' }} />


                </div>

                {/* Bottom action toolbar — icons left, Post button right */}
                <div style={{
                    borderTop: '1px solid #e4e6eb',
                    padding: '10px 12px',
                    paddingBottom: 'max(10px, env(safe-area-inset-bottom, 10px))',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    background: '#fff',
                    marginLeft: '-16px',
                    marginRight: '-16px',
                    marginBottom: '-16px',
                    marginTop: 'auto',
                    flexShrink: 0,
                }}>
                    <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                        <button type="button" onClick={() => photoInputRef.current?.click()}
                            title="Add Photo"
                            style={{ border: 'none', background: 'transparent', cursor: 'pointer', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background-color 0.2s' }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f0f2f5'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}>
                            <i className="fas fa-image" style={{ fontSize: '18px', color: '#111' }} />
                        </button>
                        <button type="button" onClick={() => videoInputRef.current?.click()}
                            title="Add Video"
                            style={{ border: 'none', background: 'transparent', cursor: 'pointer', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background-color 0.2s' }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f0f2f5'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}>
                            <i className="fas fa-video" style={{ fontSize: '18px', color: '#111' }} />
                        </button>
                        <button type="button" onClick={() => { props.handleShowB(); navigate('/audio-rooms'); }}
                            title="Audio Room"
                            style={{ border: 'none', background: 'transparent', cursor: 'pointer', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background-color 0.2s' }}
                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f0f2f5'}
                            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}>
                            <i className="fas fa-microphone" style={{ fontSize: '18px', color: '#111' }} />
                        </button>
                    </div>
                    <button
                        className="btn btn-primary rounded-pill"
                        onClick={onCreatePost}
                        disabled={isLoading || uploadInProgress}
                        style={{ fontWeight: 700, padding: '8px 28px', fontSize: '14px', letterSpacing: '0.3px' }}
                    >
                        {(isLoading || uploadInProgress) ? (
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                        ) : (
                            t('Post')
                        )}
                    </button>
                </div>
            </ModalBody>
        </Modal>
    </>)
}